import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import GroupsDetailsDrawerLocationsListItem from './groups-details-drawer-locations-list-item/groups-details-drawer-locations-list-item.component';

type GroupsDetailsDrawerLocationsListProps = {
  stores: { storeId: string; title: string }[];
};

const GroupsDetailsDrawerLocationsList = ({
  stores,
}: GroupsDetailsDrawerLocationsListProps) => {
  const { t } = useTranslation();

  return (
    <Box data-testid="GroupsLocations.List" my={3}>
      <Typography variant="h2">
        {t('drawer.groupsDetailsDrawer.locations.title')}
      </Typography>
      {stores.map(store => (
        <GroupsDetailsDrawerLocationsListItem
          key={store?.storeId}
          location={store}
        />
      ))}
    </Box>
  );
};

export default GroupsDetailsDrawerLocationsList;
